module.exports = __webpack_public_path__ + "images/icons/cards/discover-5d60ef20.svg";